import React, { useState, useEffect } from "react";
import DefectFormApi from "../../../../api/DefectForm";
import * as M from "moment";
import { IDefectHistory } from "../defectHistory/types";
import styles from "../defectHistory/defectHistory.module.scss";
import Constants from "../../../../constants/Common";

const StatusHistory: React.FC<{ defectId: string }> = ({ defectId }) => {
  const [initialStatusHistory, setInitialStatusHistory] = useState<
    IDefectHistory[]
  >([]);
  useEffect(() => {
    DefectFormApi.getStatusHistory(defectId)
      .then((res) => {
        setInitialStatusHistory(res.data);
      })
      .catch((err) => {
        console.log("история статуса не найдена", err);
      });
  }, [defectId]);

  return (
    <table className={styles.defectHistory__table}>
      <thead>
        <tr className={styles.defectHistory__tableGroupHead}>
          <th>Значение</th>
          <th>Дата и время</th>
          <th>ФИО изменившего</th>
          <th>Организация</th>
        </tr>
      </thead>
      <tbody>
        {initialStatusHistory.length > 0 ? (
          initialStatusHistory!.map((item, idx) => {
            return (
              <tr className={styles.defectHistory__tableGroupTbody} key={idx}>
                <td>{item.newValue}</td>
                <td>
                  {item.created
                    ? M(item.created).format(Constants.dateTimeFormat)
                    : Constants.notSet}
                </td>
                <td>{item.fullName}</td>
                <td>{item.employeeOrganization}</td>
              </tr>
            );
          })
        ) : (
          <tr>
            <th className={styles.defectHistory__warning}>Нет данных</th>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default StatusHistory;
